/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// material
import LabelAssignmentItem from 'material/embeds/labelassignmentfield/labelassignmentcollection/labelassignmentitem/labelassignmentitem';
import AssignmentFieldInput from 'material/embeds/labelassignmentfield/labelassignmentcollection/assignmentfieldinput/assignmentfieldinput';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/labelassignmentcollection/labelassignmentcollection_styles';



/* ========== ~~~~~~~~~~ LABEL ASSIGNMENT COLLECTION : DROPDOWN ITEM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {

    const [orderedLabelsKeys, setOrderedLabelsKeys] = useState(props.attachedLabelUUIDs);

    useEffect(() => { ensureCollectionOrder() }, [props.attachedLabelUUIDs]);

    useEffect(() => { focusOnInput() }, [props.attachedLabelUUIDs.length]);

    const ensureCollectionOrder = () => {
        /*
            When the user adds the item to the collection, it needs to show at the end of the collection.
            The BE response doesn't grantee the new item to be the last element of the returned array.
            To keep the new item from rendering in the random place,
            we ensure the added UUID is the element one in the collection array.
        */
        const renderedCollection = orderedLabelsKeys;
        const updatedCollection = props.attachedLabelUUIDs;
        let injectedItemUUIDs = updatedCollection.filter(itemUUID => !renderedCollection.includes(itemUUID));
        setOrderedLabelsKeys(!!injectedItemUUIDs.length ? [...renderedCollection, ...injectedItemUUIDs] : props.attachedLabelUUIDs)
    };

    // access child's input field directly to focus on the element on changes in collection
    const inputFieldRef = React.createRef();
    const collectionFieldRef = React.createRef();

    const renderItems = () => orderedLabelsKeys.map(labelUUID =>
        <LabelAssignmentItem key={labelUUID}
                             labelUUID={labelUUID}
                             labelName={props.labels[labelUUID]}
                             removeLabel={handleRemoveLabel}/>
    );

    const focusOnInput = () => {
        inputFieldRef.current.focus();
    };

    const handleClick = () => focusOnInput();

    const handleRemoveLabel = (labelUUID) => props.removeLabel(labelUUID);

    return (
        <ul className={`assignmentcollection ${props.classes.labelassignmentcollection}`} ref={collectionFieldRef} onClick={handleClick}>
            {renderItems()}
            <AssignmentFieldInput {...props} key={'inputitem'} ref={inputFieldRef}/>
        </ul>
    );
});
